import React from "react";
import BudgetPage from "../BudgetPage";

const BudgetWidget = () => (
  <div className="widget-content-scroll">
    <BudgetPage />
  </div>
);

export default BudgetWidget;
